// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/user_avatars.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { SrcSet } from "./images";
/**
 * @generated from protobuf message c1.api.assets.v1.UserAvatar
 */
export interface UserAvatar {
    /**
     * @generated from protobuf field: c1.api.assets.v1.UserAvatarRef user_avatar = 1;
     */
    userAvatar?: UserAvatarRef;
    /**
     * @generated from protobuf field: string src = 2;
     */
    src: string;
    /**
     * @generated from protobuf field: c1.api.assets.v1.SrcSet src_set = 3;
     */
    srcSet?: SrcSet;
}
/**
 * @generated from protobuf message c1.api.assets.v1.UserAvatarRef
 */
export interface UserAvatarRef {
    /**
     * @generated from protobuf field: string user_id = 1;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetUserAvatarsRequest
 */
export interface BulkGetUserAvatarsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.UserAvatarRef user_avatars = 1;
     */
    userAvatars: UserAvatarRef[];
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetUserAvatarsResponse
 */
export interface BulkGetUserAvatarsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.UserAvatar list = 1;
     */
    list: UserAvatar[];
}
// @generated message type with reflection information, may provide speed optimized methods
class UserAvatar$Type extends MessageType<UserAvatar> {
    constructor() {
        super("c1.api.assets.v1.UserAvatar", [
            { no: 1, name: "user_avatar", kind: "message", T: () => UserAvatarRef },
            { no: 2, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "src_set", kind: "message", T: () => SrcSet }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.UserAvatar
 */
export const UserAvatar = new UserAvatar$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAvatarRef$Type extends MessageType<UserAvatarRef> {
    constructor() {
        super("c1.api.assets.v1.UserAvatarRef", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.UserAvatarRef
 */
export const UserAvatarRef = new UserAvatarRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetUserAvatarsRequest$Type extends MessageType<BulkGetUserAvatarsRequest> {
    constructor() {
        super("c1.api.assets.v1.BulkGetUserAvatarsRequest", [
            { no: 1, name: "user_avatars", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAvatarRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetUserAvatarsRequest
 */
export const BulkGetUserAvatarsRequest = new BulkGetUserAvatarsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetUserAvatarsResponse$Type extends MessageType<BulkGetUserAvatarsResponse> {
    constructor() {
        super("c1.api.assets.v1.BulkGetUserAvatarsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserAvatar }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetUserAvatarsResponse
 */
export const BulkGetUserAvatarsResponse = new BulkGetUserAvatarsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.assets.v1.UserAvatarService
 */
export const UserAvatarService = new ServiceType("c1.api.assets.v1.UserAvatarService", [
    { name: "BulkGetUserAvatars", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetUserAvatarsRequest, O: BulkGetUserAvatarsResponse }
]);
